import 'twin.macro';
import React from 'react';
import { ClassroomMapping } from './ClassroomMapping';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { useClassroomsMapping } from './hooks/useClassroomsMapping';
import { Eleve } from '@teetsh/app/src/types/eleves';
import { Mapping } from '@teetsh/app/src/containers/Eleves/Import/File/csv';
import { ClassroomsMappingSubmit } from '@teetsh/app/src/queries/eleves/useImportEleves';
import { useTranslation } from 'react-i18next';
import useClassrooms from 'containers/App/context/ClassroomsContext/useClassrooms';

interface Props {
  eleves: Eleve[];
  onConfirm: (v: ClassroomsMappingSubmit) => void;
  isUploading?: boolean;
  rows: object[];
  mappings: Mapping[] | null;
}

export function Finalize(props: Props) {
  const { onConfirm, eleves, rows, mappings, isUploading } = props;
  const { t } = useTranslation(['eleve', 'common']);
  const { state, onUpdateEleve, onUpdateClassroom } = useClassroomsMapping(
    rows,
    mappings,
    eleves,
  );

  const existingClassrooms = useClassrooms();

  return (
    <div tw="flex flex-col gap-y-4">
      <div>
        <div tw="grid grid-cols-3 gap-4 px-4 mb-2 text-sm text-neutral-quiet">
          <div>{t('import.csvClass')}</div>
          <div>{t('import.equivalentTeetshClass')}</div>
          <div>{t('import.nationalClassId')}</div>
        </div>
        <div tw="space-y-4">
          {state.classrooms.map(cl => (
            <ClassroomMapping
              key={cl.id}
              onUpdateClassroom={onUpdateClassroom}
              classroom={cl}
              eleves={eleves}
              onUpdateEleve={onUpdateEleve}
            />
          ))}
        </div>
      </div>
      <div tw="flex justify-end">
        <Button
          intent="primary"
          loading={isUploading}
          disabled={state.classrooms.every(
            cl =>
              cl.action === 'skip' ||
              cl.eleves.every(ev => ev.action === 'skip'),
          )}
          onClick={() => {
            const classrooms = state.classrooms
              .filter(c => c.action !== 'skip')
              .map(cl => {
                // we want to preserve classroom properties, and only update idbe, so we have to restore it from existingClassrooms
                const existingClassroom = existingClassrooms.find(
                  c => c.id === (cl.action || cl.id),
                );
                return {
                  id: cl.action || cl.id,
                  idBe: cl.idBe,
                  name: existingClassroom?.name || cl.name || cl.degree,
                  cycle: existingClassroom?.cycle || cl.cycle,
                  degree: existingClassroom?.degree || cl.degree,
                  eleves: cl.eleves
                    .filter(ev => ev.action !== 'skip')
                    .map(ev => ({
                      id: ev.action || ev.id,
                      givenName: ev.givenName,
                      familyName: ev.familyName,
                      birthday: ev.birthday,
                      ine: ev.ine,
                      gender: ev.gender,
                      customFields: ev.customFields,
                    })),
                };
              });
            return onConfirm({
              classrooms,
            });
          }}
        >
          {t('common:buttons.confirm')}
        </Button>
      </div>
    </div>
  );
}
